<template>
  <div>
    <v-row
        justify="center"
        class="pt-10"
        v-if="dataSampleLoading">
      <v-col cols="12">
        <v-progress-circular indeterminate/>
      </v-col>
      <v-col cols="12">
        読み込み中
      </v-col>
    </v-row>
    <el-table
        v-else
        :data="body">
      <el-table-column
          v-for="(val, key) in headers"
          :key="key"
          :prop="`${key}.value`"
          :label="val">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'DataProfileSample',
  inject: {
    dialog: {default: null},
  },
  props: {
    dataProfileId: {
      type: String,
      required: true
    },
    assetsDataProfile: {
      type: Boolean,
      default: false,
    },
    loadImmediately: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialogDelete: {
        visible: false,
        form: {}
      },
      dataSample: null,
      dataSampleLoading: false,
    }
  },
  created() {
    if(this.loadImmediately) {
      this.load();
    } else {
      this.$watch(
          _ => [this.dataProfileId, this.dialog?.visible],
          _ => {
            if (this.dialog === null || this.dialog.visible) {
              this.load();
            }
          },
          {immediate: true}
      );
    }
  },
  computed: {
    ...mapGetters({
      hcsClient: 'hcs/client'
    }),
    headers() {
      return this.dataSample?.headers ?? {};
    },
    body() {
      return this.dataSample?.body ?? [];
    }
  },
  methods: {
    async load() {
      try {
        this.dataSampleLoading = true;
        this.dataSample = null;
        let dataSample;
        if(this.assetsDataProfile) {
          ({data: dataSample} = await this.hcsClient.get(`/assets/data_profiles/${this.dataProfileId}/data_sample`));
        } else {
          ({data: dataSample} = await this.hcsClient.get(`/data_profiles/${this.dataProfileId}/data_sample`));
        }
        this.dataSample = dataSample;
        this.$emit('load', dataSample);
      } finally {
        this.dataSampleLoading = false;
      }
    },
  },
}
</script>
